export let exportMenu = [
	{
		icon: "uil-setting sidebar-icon",
		children: [
			{
				title: true,
				i18n: "home",
			},
			{
				url: "/partner/dashboard",
				i18n: "home",
				icon: "uil-chart-growth",
				active: false,
			},
			{
				url: "/partner/analytics",
				i18n: "analytics",
				icon: "uil-chart",
				active: false,
			},
			{
				url: "/partner/ai-assistant",
				i18n: "ai_assistant",
				icon: "uil-robot",
				active: false,
			},
			{
				url: "/partner/poses",
				i18n: "poses",
				icon: "uil-shop",
				active: false,
			},
			{
				url: "/partner/pos-subscriptions",
				i18n: "pos_subscriptions",
				icon: "uil-apps",
				active: false,
			},
			{
				url: "/partner/pos-status-history",
				i18n: "pos_status_history",
				icon: "uil-history",
				active: false,
			},
			{
				url: "/partner/connections",
				i18n: "partner_connections",
				icon: "uil-plug",
				active: false,
			},
			{
				url: "/partner/transactions",
				i18n: "payment_history",
				icon: "uil-history",
				active: false,
			},
			{
				url: "/partner/users",
				i18n: "users",
				icon: "uil-users-alt",
				active: false,
			},
			{
				url: "/partner/tasks",
				i18n: "tasks",
				icon: "uil-check-square",
				active: false,
			},
			{
				url: "/partner/pos-monitor",
				i18n: "pos_monitor",
				icon: "uil-monitor",
				active: false,
			},
			{
				url: "/partner/partners-transactions",
				i18n: "bonus",
				icon: "uil-gift",
				active: false,
			},
			{
				url: "/partner/pos-percentages",
				i18n: "partner_pos_percentages",
				icon: "uil-percentage",
				active: false,
			},
			{
				url: "/partner/bonus-accrual",
				i18n: "admin_partner_bonus_accrual",
				icon: "uil-money-bill",
				active: false,
			},
			{
				url: "/partner/bonus-histories",
				i18n: "partner_my_bonuses",
				icon: "uil-transaction",
				active: false,
			},
		]
	},
]